const state = {
  reportList: [],
  checkedAllList: [],
  currentReport: '',
  hasAuth: false,
  PDFWindow: '',
  Uploader: '',
  checkeReportList: [], //当前选中的那条pdf
  checkeReportUrl: '', //当前选中的那条pdf
  reportleftList: [], //左侧文件数组
};
const getters = {
  // 左侧文件数组
  reportleftList(state) {
    return state.reportleftList;
  },
  checkeReportUrl(state) {
    return (state.checkeReportList[0] && state.checkeReportList[0].url) || '';
  },
};
const actions = {
  async getFileList({ commit }, obj) {
    commit('REPORTLEFTLIST', obj);
  },
  async getFileRow({ commit }, obj) {
    commit('CHECKREPORTLIST', obj);
  },
};
const mutations = {
  REPORTLIST(state, payload) {
    state.reportList = payload;
  },
  CHECKEDALLLIST(state, payload) {
    state.checkedAllList = payload;
  },
  CURRNTREPORT(state, payload) {
    sessionStorage.setItem('currentReport', JSON.stringify(payload));
    state.currentReport = payload;
  },
  HASAUTH(state, payload) {
    state.hasAuth = payload;
  },
  PDFWINDOW(state, payload) {
    state.PDFWindow = payload;
  },
  REPORTLEFTLIST(state, payload) {
    state.reportleftList = payload;
  },
  CHECKREPORTLIST(state, payload) {
    state.checkeReportList = payload;
  },
  CHECKREPORTURL(state, payload) {
    state.checkeReportUrl = payload;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
